import React from "react";
import LBGroupTable from "./LBGroupTable.js";
import SelectStores from "./SelectStoresSection.js";
import LeaderboardMembers from "./leaderboardMembers.js";
import SuccessAlert from "../Alerts/SuccessAlert";
import ErrorAlert from "../Alerts/ErrorAlert";
import fetch from "isomorphic-fetch";
import { confirmAlert } from "react-confirm-alert";
import t from "../Language/language";
import * as languageSettings from "../Language/languageSettings";
import AuthenticationService from "../Security/AuthenticationService";
import { Link } from "react-router-dom";
import { Config } from "../../Config";
import { CommonConstants } from "../../Constants";
import "url-search-params-polyfill";
import Api from "../../Api";
import "../Group/ReportGroup.css";
import "react-confirm-alert/src/react-confirm-alert.css";
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import CommonLoader from "../Alerts/CommonLoader";
import { get, save, remove, getCompanyDetail, setInviteDetails, inviteLBGroupUser, getLBGroupUsers, deleteLBGroupUser } from "../../actions/leaderboardGroup";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Modal } from "react-bootstrap";
import ReCAPTCHA from "react-google-recaptcha";
import { getEmailIdCount } from './helpers/formatting';
var _ = require("underscore");


class LeaderBoardGroup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentLanguage: languageSettings.getCurrentLanguage(),
      language: languageSettings.getCurrentLanguage(),
      available: [],
      assigned: [],
      counter: 0,
      successMessage: "",
      errorMessage: "",
      isEdit: false,
      isAdmin: false,
      accountId: 100,
      GroupUID: null,
      isDefault: null,
      GroupNotSelectedError: "",
      saveSuccess: false,
      deleteSuccess: false,
      userContext: {},
      showCommonLoader: false,
      dbAssignedStoreUIDs: [],
      showStoreAssignment: false,
      showStoreAssignmentConfirm: false,
      companyDetails: {},
      selectedGroupID: "",
      showInviteError: false,
      showInviteEmailError: false,
      showEmailLanguageError: false,
      showMultipleEmailsError: false,
      inviteeEmail: "",
      availableStores: [],
      groupMembers: [],
      inviteErrorMessage: "",
      defaultGroupId: null,
      isInvite: null,
      groupStoreList: null,
      checkedStores: [],
      treeList: [],
      DefaultGroupName: ""
    };
    this.api = new Api();
    this.authService = new AuthenticationService(Config.authBaseUrl);
    this.renderButtonGroups = this.renderButtonGroups.bind(this);
  }

  componentWillMount() {
    this.setState({ showCommonLoader: true });
    const params = new URLSearchParams(this.props.history.location.search);
    const GroupUID = params.get("GroupUID") ? params.get("GroupUID") : null;
    const isDefault = params.get("IsDefault") ? parseInt(params.get("IsDefault")) : null;
    const isAdmin = params.get("ia") ? params.get("ia") : null;
    let isInvite = params.get("invite") ? params.get("invite") : null;
    this.state.isInvite = isInvite;

    this.setState({ GroupUID });
    this.setState({ isDefault });
    this.setState({ isAdmin });

    if (GroupUID) {
      this.setState({ isEdit: true });
      this.populateGroupDetails(GroupUID);
      this.props.getLBGroupUsers(GroupUID, data => {
        if (data.status) {
          this.setState({ showLoader: "hidden" });
          this.setState({ groupMembers: data });
        } else {
          console.log("Request failed.");
        }
      });
    }

    this.getCompanyUUID();
    this.state.userContext = this.authService.getProfile();
  }

  getCompanyUUID() {
    this.props.getCompanyDetail(data => {
      if (data.status === false) {
        this.setState({ successMessage: data.data, errorMessage: "" });
      } else {
        this.state.companyDetails = data;
        this.getAvailableGroupStoreList(data.companyUId);
      }
      this.setState(this.state);
    });
  }

  getAvailableGroupStoreList(companyUUID) {
    let language = this.state.currentLanguage;
    this.state.available = [];
    let url = Config.apiBaseUrl + CommonConstants.apiUrls.getLBgroupsAvailable + "/" + companyUUID;
    this.api.getData(
      url,
      data => {
        let GroupUID = this.state.GroupUID;
        let available = data.data ? data.data : [];
        // filter the available list so that it displays only comapany stores
        available = _.filter(available, function(store) {
          if(store.CompanyUID === null){
            store.disabled = true;
          }
          return store.CompanyUID === companyUUID || store.CompanyUID === null;
        });
        this.setState({ available });

        // find the default group details in the store list and set the Default tag to all default group name
        _.each(available, str => {
          if( str.isDefault && str.GroupCompanyUID === companyUUID) {
            str.GroupName += t[language].Default; 
            this.setState({ defaultGroupId: str.GroupUID });
            this.setState({ DefaultGroupName: str.GroupName });
            return true;
          } else {
            return false;
          }
        });
        
        if (GroupUID != null) {
          // filter the available list so that it displays only other LB group stores(not including the current LBGroup)
          let storeUIDs = _.filter(available, function(store) {
            return store.GroupUID !== GroupUID;
          });
          this.setState({ available: storeUIDs });
          this.makeTreeStructure(storeUIDs);
        } else {
          this.makeTreeStructure(available);
        }
        this.setState(this.state);
        this.setState({ showCommonLoader: false });
      },
      error => {
        this.state.successMessage = "";
        this.state.errorMessage = error.message;
        this.setState(this.state);
        this.setState({ showCommonLoader: false });
      }
    );
  }

  makeTreeStructure(available){
    console.time();
    let res = _.chain(available)
        .sortBy("StoreName")
        .sortBy(str => parseInt(str.StoreNumber))
        .groupBy("GroupName")
        .map((val, key) => {
          if(!_.some(val, store => { return store.disabled; })){
            let dummyField = {CompanyUID: null, GroupName: key, GroupID: val[0].GroupID, isDefault: val[0].isDefault, disabled: true, StoreUID: null, StoreName: null, StoreNumber: null, GroupCompanyUID: val[0].GroupCompanyUID,};
            this.state.available.push(dummyField);
          }
          return {
            GroupName: key,
            GroupID: val[0].GroupID,
            isDefault: val[0].isDefault,
            GroupCompanyUID: val[0].GroupCompanyUID,
            Stores: val
          };
        })
        .sortBy(str => (str.GroupName).toLowerCase())
        .sortBy(str => !(str.isDefault && str.GroupCompanyUID === this.state.companyDetails.companyUId))
        .value();
    this.state.treeList = res;
    this.state.checkedStores = [];
    console.timeEnd();
  }

  populateGroupDetails(GroupUID) {
    GroupUID = GroupUID === undefined ? this.state.GroupUID : GroupUID;

    if (GroupUID) {
      this.props.get(GroupUID, data => {
        if (data.status === false) {
          this.setState({ successMessage: data.data, errorMessage: "", assigned: [] });
        } else {
          let groupDetails = data.groupDetails[0];
          this.refs.groupName.value = groupDetails.GroupName;
          this.refs.groupDescription.value = groupDetails.GroupDesc;
          this.setState({ dbAssignedStoreUIDs: data.storesInGroup, assigned: data.storesInGroup });
        }
        this.setState(this.state);
      });
    } else {
      this.setState(this.state);
      this.refs.groupName.value = "";
      this.refs.groupDescription.value = "";
    }
  }

  renderButtonGroups(assigned) {
    let language = this.state.currentLanguage;
    return (
      <div className="row reportgroup-buttons">
        {/* <div>
          <a className="cursor-pointer leaderBoardSettings" onClick={this.lbSettings.bind(this)}>
            {t[language].leaderboardsettings}
          </a>
        </div> */}

        <div className="col-xs-12 group-btns">
          <div>
            <button type="button" className="btn btn-primary save-group-btn" onClick={this.checkStoreSelection.bind(this, assigned)}>
              {t[language].save}
            </button>
          </div>
          <div>
            <span className={"btn-pipe"}> | </span>
          </div>
          <div>
            <Link to="/leaderBoards" className="reportgroup-cancel">
              {t[language].cancel}
            </Link>
          </div>
        </div>
      </div>
    );
  }

  lbSettings() {
    window.location.href = "/leaderboard";
  }

  moveToRight(source, target) {
    var index = 0;
    while (index < source.length) {
      var item = source[index];
      if (_.contains(this.state.checkedStores, item.StoreUID)) {
        target.push(item);
        source.splice(index, 1);
      } else {
        index++;
      }
    }
  }

  moveToLeft(source, target) {
    var index = 0;
    while (index < source.length) {
      var item = source[index];
      if (item.selected) {
        item.selected = false;
        if(item.IsLBGroupStore != null && item.IsLBGroupStore === 1){
          // console.log("This is Current LB Store");
          item.GroupName = this.state.DefaultGroupName;
          item.isDefault = 1;
        }
        target.push(item);
        source.splice(index, 1);
      } else {
        index++;
      }
    }
  }

  toggle(item) {
    item.selected = !item.selected;
    this.setState(this.state);
  }

  selectAll(event, list) {
    list.map((item, index) => {
      if (item.CompanyUID === this.state.companyDetails.companyUId) {
        item.selected = event.target.checked;
      }
    });
    this.setState(this.state);
  }

  add() {
    // console.log("1: ", this.state.checkedStores)
    if(this.state.checkedStores.length != 0){
      this.moveToRight(this.state.available, this.state.assigned);
      this.makeTreeStructure(this.state.available);
      this.setState(this.state);
    }
  }
  remove() {
    // console.log("**************Zero Storez: ", _.some(this.state.assigned, store => { return store.selected; }));
    if(_.some(this.state.assigned, store => { return store.selected; })){
      this.moveToLeft(this.state.assigned, this.state.available);
      this.makeTreeStructure(this.state.available);
      document.getElementById("assigned").checked = false;
      this.setState(this.state);
    }
  }

  // function to display popup if there are no company stores selected
  checkStoreSelection(items) {
    console.log(">>>>>>>>>>>>Saved List: ", items);
    let isStoreSelected = _.some(items, item => {
      return item.CompanyUID === this.state.companyDetails.companyUId;
    });
    console.log("Store selected in LB: ", isStoreSelected);
    if (!isStoreSelected) {
      this.renderConfirmModal(items);
    } else {
      this.saveAssigned(items);
    }
  }

  // Method for render Confirm Modal for 0 store selection.
  renderConfirmModal = items => {
    const { language } = this.state;
    confirmAlert({
      title: t[language].storeSelection,
      message: t[language].selectNoStores,
      buttons: [
        {
          label: t[language].yes,
          onClick: () => {
            this.saveAssigned(items);
          },
        },
        {
          label: t[language].no,
          onClick: () => {},
        },
      ],
    });
  };

  saveAssigned(items) {
    this.state.showCommonLoader = true;
    this.setState(this.state);
    let availList = this.state.available;
    availList = _.filter(availList, store => {
      return store.IsLBGroupStore === 1;
    });
    let language = this.state.currentLanguage;
    this.refs.groupName.value = this.refs.groupName.value.trim();

    let storeUIDS = _.pluck(items, "StoreUID");
    this.setState(this.state);

    if (this.refs.groupName.value === "" || this.refs.groupName.value === undefined) {
      this.state.errorMessage = t[language]["Group name may not be blank"];
      this.state.successMessage = "";
      this.setState(this.state);
      this.state.showCommonLoader = false;
      this.setState(this.state);
    } else {
      let data = {};
      data = {
        GroupUID: this.state.GroupUID ? this.state.GroupUID : 0,
        storeUids: storeUIDS,
        groupName: this.refs.groupName.value,
        groupDesc: this.refs.groupDescription.value,
        isActive: 1,
        lastUpdatedBy: this.state.userContext.User_EmailAddress,
        companyUID: this.state.companyDetails.companyUId,
        defaultGroupId: this.state.defaultGroupId,
        defaultStoreUIDs: _.pluck(availList, "StoreUID"),
      };
      this.props.save(data, data => {
        if (data.status) {
          let self = this;
          this.state.successMessage = t[language][data.key];
          this.state.errorMessage = "";
          this.state.saveSuccess = true;
          this.setState(this.state);
          this.props.history.push("/message", data.key);
          setTimeout(function() {
            if (window.location.pathname.indexOf("/message") !== -1) {
              self.props.history.push("/leaderBoards");
            }
          }, 3000);
        } else {
          this.state.showCommonLoader = false;
          this.setState(this.state);
          console.log("Error: ", data.key);
          this.state.errorMessage = t[language][data.key];
          let errors = [];
          errors.push(t[language][data.key]);
          this.setState(errors);
          this.state.successMessage = "";
          this.setState(this.state);
        }
      });
    }
  }

  handleFormChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  //#region render calls for Group members table and it's associated popups
  renderInviteModal() {
    const { language } = this.state;
    let showInvite = this.state.showInvite;
    let closeModal = () =>
      this.setState({
        showInvite: false,
        showInviteError: false,
        showLoader: "hidden",
        showInviteEmailError: false,
        showEmailLanguageError: false,
        showMultipleEmailsError: false,
        inviteeEmail: null,
        inviteErrorMessage: null,
      });
    let sendInvite = async () => {
      this.setState({ showLoader: "visible" });
      this.setState({ showInviteError: false, showInviteEmailError: false });
      this.setState({ inviteErrorMessage : ""})
      let invalidEmail = true;
      // let invalidEmailLanguage = true;
      if (this.state.inviteeEmail === null || this.state.inviteeEmail === undefined || this.state.inviteeEmail === "") {
        this.setState({ showInviteEmailError: true });
        invalidEmail = true;
      } else {
        invalidEmail = false;
      }

      let repeatFlag = false;
      let groupMembers = this.state.groupMembers.data;

      repeatFlag = _.some(groupMembers, member => {
        return member.UserEmail === this.state.inviteeEmail;
      });
      console.log("Repeat val: ", repeatFlag);

      // Check if invitation input contains multiple email ids.
      // Multiple email id are not allowed for now, so show an error, BUG #30769.
      let showMultipleEmailsError = false;
      const emailIdCount = getEmailIdCount(this.state.inviteeEmail);
      showMultipleEmailsError = (emailIdCount > 1) ? true: false;
      this.setState({ showMultipleEmailsError })

      if (repeatFlag) {
        this.setState({ showInviteError: true });
      }
      if (invalidEmail) {
        this.setState({ showInviteEmailError: true });
      }
      // if(invalidEmailLanguage){
      //   this.setState({ showEmailLanguageError: true });
      // }
      if (!invalidEmail && !repeatFlag && !showMultipleEmailsError) {
        this.props.setInviteDetails({
          UserEmail: this.state.inviteeEmail,
          GroupUID: this.state.GroupUID,
          InvitedBy_UserUID: this.state.uuid,
          CompanyUID: this.state.companyDetails.companyUId,
          // Email_Language: this.state.emailLanguage
        });

        await this.props.inviteLBGroupUser(res => {
          console.log("Invite: ", res);

          if (res.status) {
            let self = this;
            this.state.successMessage = t[language][res.key];
            this.state.errorMessage = "";
            this.state.saveSuccess = true;
            this.setState(this.state);
            this.props.history.push("/message", res.key);
            setTimeout(function() {
              if (window.location.pathname.indexOf("/message") !== -1) {
                self.props.history.push(
                  "/leaderBoards/leaderboardGroup?GroupUID=" + self.state.GroupUID + `&IsDefault=${self.state.isDefault}` + `&ia=${self.state.isAdmin}`,
                );
              }
            }, 3000);
            this.setState({ showInvite: false });
            this.setState({ showInviteError: false });
            this.setState({ showInviteEmailError: false });
            this.setState({ showEmailLanguageError: false });
            this.setState({ inviteeEmail: null });
            this.setState({ showLoader: "hidden" });
          } else {
            this.state.showCommonLoader = false;
            this.setState(this.state);
            console.log("Error: ", t[language][res.key]);
            this.state.inviteErrorMessage = t[language][res.key];
            let errors = [];
            errors.push(t[language][res.key]);
            this.setState(errors);
            this.state.successMessage = "";
            this.setState(this.state);
          }
        });
      }
      this.setState({ showInviteConfirm: false });
    };

    let verifyReCaptcha = () => {
      this.setState({ showInviteConfirm: true });
    };

    return (
      <Modal show={showInvite} onHide={closeModal} aria-labelledby="ModalHeader">
        <Modal.Header closeButton>
          <Modal.Title id="ModalHeader" className="store-modal-content">
            {t[language].Invite} {t[language].Members}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className={"render-invite-success " + (this.state.GroupNotSelectedError ? "hidden" : "")}>
            <ErrorAlert errorMessage={this.state.inviteErrorMessage} />
            <span>{t[language].emailaddress} </span>
            <input
              id="inviteeEmail"
              name="inviteeEmail"
              type="email"
              required
              pattern="[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*"
              onChange={e => this.handleFormChange(e)}
            />
            <div>
              <span className={"invite-error " + (this.state.showInviteError ? "" : "hidden")} id="errMsgDuplicateUser">
                {t[language].invitationMailAlreadySentToUser}
              </span>
            </div>
            <div>
              <span className={"invite-email-error " + (this.state.showInviteEmailError ? "" : "hidden")} id="errMsgDuplicateUser">
                {t[language].InvalidEmail}
              </span>
            </div>

            <div>
              <span className={"invite-email-error " + (this.state.showEmailLanguageError ? "" : "hidden")} id="errMsgDuplicateUser">
                {t[language].InvalidEmailLanguage}
              </span>
            </div>

            <div>
              <span className={"invite-email-error " + (this.state.showMultipleEmailsError ? "" : "hidden")} id="errMsgDuplicateUser">
                {t[language].multipleEmailsErrorMessage}
              </span>
            </div>

            {/*<ReCAPTCHA className="paddingOnTop" sitekey="6LcZZHkUAAAAAFjr4mFbZqWJSo966qSMDMK2cSr1" onChange={verifyReCaptcha} />*/}
            <button className={"btn btn-primary paddingOnLeft paddingOnTop fright " + (this.state.showInviteConfirm ? "show" : "")} onClick={sendInvite}>
              {t[language].SendInvite}
            </button>
          </div>

          <div className={"render-invite-error " + (this.state.GroupNotSelectedError ? "" : "hidden")}>
            <span>{t[language].pleaseSelectALeaderBoardGroup} </span>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <span>* {t[language].enterSingleEmailMessage} </span>
        </Modal.Footer>
      </Modal>
    );
  }

  toggleInviteModal() {
    this.setState({ showInvite: true });
  }

  getUsers() {
    if (this.state.isEdit) {
      this.props.getLBGroupUsers(this.state.GroupUID, data => {
        if (data.status) {
          this.setState({ groupMembers: data });
          this.setState({ showLoader: false });
        } else {
        }
      });
    }
  }

  render() {
    let language = this.state.currentLanguage;
    let assigned = this.state.assigned;
    // console.log("******************Checked Stores : ", this.state.checkedStores);
    // console.log("Result: ", this.state.treeList);
    return (
      <section>
        <CommonLoader showLoader={this.state.showCommonLoader} message={"Loading..."} />
        <section className={"groupDetailsPage " + (this.state.showCommonLoader ? "hide" : "show")}>
          <div className="status-messages">
            {/* <SuccessAlert successMessage={this.state.successMessage} /> */}
            <ErrorAlert errorMessage={this.state.errorMessage} />
          </div>
          <section className={"report-container " + (this.state.saveSuccess || this.state.deleteSuccess ? "hide" : "show")}>
            <div className={this.state.isEdit ? "show" : "hidden"}>
              <h1>
                {t[language].EditLeaderboardDetails +
                  (this.state.isDefault === 1 && this.state.isAdmin === "true" ? " (" + t[language].DefaultGroup + ")" : "")}
              </h1>
            </div>
            <div className={!this.state.isEdit ? "show" : "hidden"}>
              <h1>{t[language].AddNewLeaderboard}</h1>
            </div>
            <div className="row reportgroup-name">
              <div className="form-group">
                <div className="col-xs-12 col-sm-12 col-md-3 col-lg-2">
                  <label htmlFor="groupName" className="control-label group-name-label">
                    <b>{t[language].LeaderboardName}:</b>
                    <span className="redSpan">*</span>
                  </label>
                </div>
                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-4">
                  <input
                    type="text"
                    ref="groupName"
                    className="form-control"
                    maxLength="50"
                    disabled={this.state.isEdit && this.state.isAdmin != "true" ? "disabled" : ""}
                  />
                </div>
              </div>
            </div>

            <div className="row report-description">
              <div className="form-group">
                <div className="col-xs-12 col-sm-12 col-md-3 col-lg-2">
                  <label htmlFor="groupName" className="control-label group-label-description">
                    <b>{t[language].LeaderboardDescription}:</b>
                  </label>
                </div>
                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-4">
                  <textarea
                    rows="4"
                    ref="groupDescription"
                    cols="53"
                    className="form-control"
                    maxLength="200"
                    disabled={this.state.isEdit && this.state.isAdmin != "true" ? "disabled" : ""}
                  />
                </div>
              </div>
            </div>

            <div className={this.state.isInvite === "true" ? "" : "hidden"}>
              <label className={"new-msg"}>{t[language].selectStoresMsg}</label>
            </div>

            <div className="row group-seperation">
              <div className={this.state.isDefault === 1 && this.state.isAdmin === "true" ? "hidden" : ""}>
                {/* GroupTable renders all the stores from the current user account in an tree structure  */}
                <SelectStores
                  data={this.state.treeList}
                  title={t[language].availablestores}
                  checkedStores={this.state.checkedStores}
                  setCheckedStores={checkedStores => this.setState({ checkedStores })}
                />
                <div className="raiseAddRemoveButtons col-xs-12 col-sm-12 col-md-2 col-lg-2 move-group-store">
                  <div className="moveToHierarchy pull-center">
                    <button className="btn btn-default" onClick={this.add.bind(this)}>
                      &gt;
                    </button>
                  </div>
                  <div className="removeFromToHierarchy pull-center">
                    <button className="btn btn-default" onClick={this.remove.bind(this)}>
                      &lt;
                    </button>
                  </div>
                </div>
              </div>
              {/* LBGroupTable renders the stores only from the current Leaderboard  */}
              {/* isDefault is an flag used for displaying stores in an default group  */}
              <LBGroupTable
                title={t[language].ParticipatingStores}
                items={this.state.assigned}
                selectAll={(e, items) => this.selectAll(e, items)}
                toggle={item => this.toggle(item)}
                type="assigned"
                company={this.state.companyDetails}
                isDefault={this.state.isDefault === 1 && this.state.isAdmin === "true"}
             />
           </div>
           {this.renderButtonGroups(assigned)}
          </section>
        </section>
        {this.renderInviteModal()}
        <div className={this.state.showCommonLoader === false && this.state.isEdit ? "ctable fleft membersTablePositioning" : "hidden"}>
          <span className="memberTableHeader">{t[language].participatingAccounts} </span>
          <div className="memberTableHeader">
            <LeaderboardMembers
              isAdmin={this.state.isAdmin}
              members={this.state.groupMembers.data}
              assignedStores={this.state.assigned}
              isDefault={this.state.isDefault}
              renderLBGroupDetails={this.populateGroupDetails.bind(this)}
              GroupUID={this.state.GroupUID}
              toggleInviteModal={this.toggleInviteModal.bind(this)}
              getMembers={this.getUsers.bind(this)}
              CompanyUID={this.state.companyDetails.companyUId}
            />
          </div>
        </div>
      </section>
    );
  }
}

function mapStateToProps(state) {
  return {};
}
function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getCompanyDetail: getCompanyDetail,
      save: save,
      remove: remove,
      get: get,
      getLBGroupUsers,
      setInviteDetails,
      inviteLBGroupUser,
      deleteLBGroupUser,
    },
    dispatch,
  );
}
export default connect(
  mapStateToProps,
  matchDispatchToProps,
)(LeaderBoardGroup);



// WEBPACK FOOTER //
// ./src/components/LeaderBoard/LeaderBoardGroup.js